import axiosInstance from '../../utils/axiosInstance';
// import { generateMockActivity } from './mockActivity';

const API_URL = process.env.REACT_APP_API_ACTIVITY;

// const PAGE_SIZE = 50;

// export const fetchActivityLogs = async ({page = 1, size = 10, offset= 10}) => {
//     console.log()
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       const all = generateMockActivity();
//       const start = (page - 1) * PAGE_SIZE;
//       const data = all.slice(start, start + PAGE_SIZE);
//       resolve({
//         data,
//         total: all.length,
//       });
//     }, 500);
//   });
// };
export const fetchActivityLogs = async ({ page = 1, size = 10 }) => {
//   const offset = (page - 1) * size;

  const params = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
  });
  const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
  return response.data;
};
